import { render, staticRenderFns } from "./with_training.vue?vue&type=template&id=2044f44e&"
import script from "./with_training.vue?vue&type=script&lang=js&"
export * from "./with_training.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports